import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'

import AnswerModal from './component'

const mapStateToProps = state => {
  const question = PlaybookSelectors.getCurrentQuestionByAnswer(state)
  return {
    questionIndex: question && PlaybookSelectors.getQuestionIndex(state, { id: question.id }),
    answer: PlaybookSelectors.getCurrentAnswer(state),
    isEmailCaptureQuestion: PlaybookSelectors.isEmailCaptureQuestion(state, question),
    isPhoneCaptureQuestion: PlaybookSelectors.isPhoneCaptureQuestion(state, question),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideAnswerModal: PlaybookActions.hideAnswerModal,
      setResponse: PlaybookActions.setResponse,
      flagAnswer: PlaybookActions.flagAnswer,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    targetCopy: props.isEmailCaptureQuestion
      ? 'email address'
      : props.isPhoneCaptureQuestion ? 'phone number' : 'response',
    shortTargetCopy: props.isEmailCaptureQuestion
      ? 'email'
      : props.isPhoneCaptureQuestion ? 'phone number' : 'response',
  })),
  withHandlers({
    onCloseClick: props => () => {
      const { actions: { hideAnswerModal }} = props
      hideAnswerModal()
    },
    onResponseChange: props => value => {
      const { actions: { setResponse }, answer: { id: answerId }} = props
      setResponse({ answerId, response: value })
    },
  })
)(AnswerModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/index.js